import { queryString } from '@qadra/frontend-common';
import { apiPaths } from '../utils';

function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const apiCall = (url, body) =>
  new Promise((resolve, reject) => {
    fetch(url, {
      body: queryString.stringify(body),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-XSRF-TOKEN': getCookie('XSRF-TOKEN'),
      },
      method: 'POST',
      credentials: 'include',
    })
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          res
            .json()
            .then((json) => resolve(json))
            .catch(() => reject('Server error'));
        } else {
          res
            .json()
            .then((json) => reject(json))
            .catch(() => reject('Server error'));
        }
      })
      .catch((e) => reject(e.message));
  });

export const apiLoginPost = (body) => apiCall(apiPaths.login, body);
export const apiForgotPasswordPost = (body) => apiCall(apiPaths.forgotPassword, body);
export const apiResetPasswordPost = (body) => apiCall(apiPaths.resetPassword, body);
export const apiActivatePost = (body) => apiCall(apiPaths.activate, body);
export const apiConfirmEmailPost = (body) => apiCall(apiPaths.confirmEmail, body);
